import { AdminAppState, EventEntry, PosterImageType } from '../../state';
import { getEventPosterImages } from './get-event-poster-images';

export const getEventPosterImage = (
  eventKey: string,
  type: PosterImageType = PosterImageType.Generic,
) => (state: AdminAppState): EventEntry['event']['posterImages'][0] | null => {
  const posterImages = getEventPosterImages(eventKey)(state);
  return posterImages.find(image => image.type === type) || null;
};
